import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'subjects' })
export class Subject extends HierarchyNode {}
